import { getCookie } from '@/services/cookie'
import { cookieConstant } from '@/services/constants'
import {
  getVisitorAttributes
} from '@/services/utils'
import store from '@/store'

export default {
  /**
   * @param {*} userId optional
   * Free-form dictionary of traits of the user,
   * like email or name. See the Traits field docs(https://segment.com/docs/connections/spec/identify#traits)
   * for a list of reserved trait names.
   *
   * @param {*} traits optional if anonymousID is set instead
   * Unique identifier for the user in your database.
   * A userId or an anonymousId is required. See the Identities docs(https://segment.com/docs/connections/spec/identify#identities)
   * for more details.
   */
  identify(userId, traits) {
    try {
      window.analytics.identify(userId, traits)
    } catch (err) {
      console.log('Error in identify Segment API call', err.message)
    }
  },
  /**
   * @param {*} event required Name of the action that a user has performed
   * @param {*} properties optional Free-form dictionary of properties of the event, like revenue.
   * See the Properties docs for a list of reserved property names. https://segment.com/docs/connections/spec/track#properties
   */
  track(event, properties) {
    try {
      const { getBotRefId } = store?.getters || {}
      properties = {
        conversationId: getCookie(cookieConstant.SESSION.CONVERSATION_ID),
        userId: store?.getters?.getUserId,
        botRefId: getBotRefId,
        ...getVisitorAttributes(),
        ...properties
      }
      window.analytics.track(event, properties)
    } catch (err) {
      console.log('Error in Track Segment API call', err)
    }
  },
  /**
   * @param {*} name optional Name of the page For example, most sites have a “Signup” page
   *
   * @param {*} properties Free-form dictionary of properties of the page, like url and referrer
   * See the Properties field docs(https://segment.com/docs/connections/spec/page#properties)
   * for a list of reserved property names.
   */
  page({ name, properties }) {
    try {
      window.analytics.page({ name, properties })
    } catch (err) {
      console.log('Error in Page Segment API call', err.message)
    }
  },
  /**
   * @param {*} groupId required A unique identifier for the group in your database.
   * See the Group ID field docs(https://segment.com/docs/connections/spec/group#group-id) for more detail.
   * @param {*} traits optional Free-form dictionary of traits of the group, like email or name See
   * the Traits field docs(https://segment.com/docs/connections/spec/group#traits) for a list of reserved trait names.
   */
  group({ groupId, traits }) {
    try {
      window.analytics.group(groupId, traits)
    } catch (err) {
      console.log('Error in Group Segment API call', err.message)
    }
  },
  /**
   * @param {*} previousId required Previous unique identifier for the user See the Previous ID
   * field docs(https://segment.com/docs/connections/spec/alias#previous-id) for more details.
   * @param {*} userId Unique identifier for the user in your database
   */
  alias(previousId, userId) {
    try {
      window.analytics.alias({ previousId, userId })
    } catch (err) {
      console.log('Error in Alias Segment API call', err.message)
    }
  }
}
